// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as React from "react";
import * as MapUtils from "../map-mods-tbd-catalyst/utils/MapUtils.bs.js";
import * as MapConfig from "../map-mods-tbd-catalyst/utils/MapConfig.bs.js";
import * as MarkerMod from "../map-mods-tbd-catalyst/types/MarkerMod.bs.js";
import * as Caml_array from "../../../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as MarkerComponentMod from "../map-mods-tbd-catalyst/views/MarkerComponentMod.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";

var acceptTooltipTitle = "Trip Accepted";

var pickupTooltipTitle = "Pickup Location";

var dropTooltipTitle = "Drop Location";

var tripStartTooltipTitle = "Trip Started";

var tripEndTooltipTitle = "Trip Ended";

var wayPointTooltipTitle = "Waypoint";

var cancelledTooltipTitle = "Cancelled";

var multiAnchorPoints_0 = {
  iconAnchor: [
    15,
    38
  ],
  popupAnchor: [
    -5,
    -38
  ]
};

var multiAnchorPoints_1 = {
  hd: {
    iconAnchor: [
      -15,
      38
    ],
    popupAnchor: [
      25,
      -38
    ]
  },
  tl: {
    hd: {
      iconAnchor: [
        15,
        62
      ],
      popupAnchor: [
        -5,
        -62
      ]
    },
    tl: {
      hd: {
        iconAnchor: [
          -15,
          62
        ],
        popupAnchor: [
          25,
          -62
        ]
      },
      tl: {
        hd: {
          iconAnchor: [
            15,
            86
          ],
          popupAnchor: [
            -5,
            -86
          ]
        },
        tl: {
          hd: {
            iconAnchor: [
              -15,
              86
            ],
            popupAnchor: [
              25,
              -86
            ]
          },
          tl: /* [] */0
        }
      }
    }
  }
};

var multiAnchorPoints = {
  hd: multiAnchorPoints_0,
  tl: multiAnchorPoints_1
};

var singleAnchorPoints_iconAnchor = [
  8,
  40
];

var singleAnchorPoints_popupAnchor = [
  3,
  -40
];

var singleAnchorPoints = {
  iconAnchor: singleAnchorPoints_iconAnchor,
  popupAnchor: singleAnchorPoints_popupAnchor
};

function getTsString(time) {
  return Timestamp$Catalyst.toString(time, "Do MMM' YY, HH:mm");
}

function getMarkerTs($$location) {
  if ($$location.TAG === /* WithTime */0) {
    return Timestamp$Catalyst.toString($$location._0.ts, "Do MMM' YY, HH:mm");
  } else {
    return "";
  }
}

function getMarker($$location, icon, toolTipInfo) {
  var tmp;
  tmp = $$location.TAG === /* WithTime */0 ? $$location._0.point : $$location._0;
  return {
          location: tmp,
          icon_data: icon,
          tooltip: toolTipInfo
        };
}

function getMarkerLatLng($$location) {
  if ($$location.TAG === /* WithTime */0) {
    return $$location._0.point;
  } else {
    return $$location._0;
  }
}

function getSingleMarkerHolder(coordinate) {
  return React.createElement(MarkerComponentMod.make, {
              config: MarkerMod.make_props(coordinate, undefined, undefined, undefined, Caml_option.some(MapConfig.single_holder_icon), Caml_option.some([
                        0,
                        20
                      ]), undefined, undefined, undefined, undefined, undefined, undefined, undefined),
              children: null,
              key: "single-marker-holder"
            });
}

function getMultiMarkerHolder(coordinate) {
  return React.createElement(MarkerComponentMod.make, {
              config: MarkerMod.make_props(coordinate, undefined, undefined, undefined, Caml_option.some(MapConfig.multi_holder_icon), Caml_option.some([
                        0,
                        20
                      ]), undefined, undefined, undefined, undefined, undefined, undefined, undefined),
              children: null,
              key: "mutli-marker-holder"
            });
}

function getMarkersViews(locationInfo, orderStatus, driverRoute) {
  var waypointArray = locationInfo.waypoint_locs;
  return {
          accept: Belt_Option.flatMap(locationInfo.accepted_loc, (function (acceptedLocation) {
                  return getMarker(acceptedLocation, {
                              TAG: /* Img */0,
                              _0: MapConfig.accept_icon
                            }, {
                              title: acceptTooltipTitle,
                              ts: getMarkerTs(acceptedLocation),
                              address: undefined
                            });
                })),
          pickup: getMarker(locationInfo.pickup_loc.location, {
                TAG: /* Img */0,
                _0: MapConfig.pickup_icon
              }, {
                title: pickupTooltipTitle,
                ts: getMarkerTs(locationInfo.pickup_loc.location),
                address: locationInfo.pickup_loc.address
              }),
          drop: getMarker(locationInfo.drop_loc.location, {
                TAG: /* Img */0,
                _0: MapConfig.drop_icon
              }, {
                title: dropTooltipTitle,
                ts: getMarkerTs(locationInfo.drop_loc.location),
                address: locationInfo.drop_loc.address
              }),
          trip_start: Belt_Option.flatMap(locationInfo.trip_started_loc, (function (tripStartedLocation) {
                  return getMarker(tripStartedLocation.location, {
                              TAG: /* Img */0,
                              _0: MapConfig.start_icon
                            }, {
                              title: tripStartTooltipTitle,
                              ts: getMarkerTs(tripStartedLocation.location),
                              address: tripStartedLocation.address
                            });
                })),
          trip_end: Belt_Option.flatMap(locationInfo.trip_ended_loc, (function (tripEndedLocation) {
                  return getMarker(tripEndedLocation.location, {
                              TAG: /* Img */0,
                              _0: MapConfig.end_trip_icon
                            }, {
                              title: tripEndTooltipTitle,
                              ts: getMarkerTs(tripEndedLocation.location),
                              address: tripEndedLocation.address
                            });
                })),
          waypoint: waypointArray !== undefined ? $$Array.mapi((function (index, a) {
                    return getMarker(a.location, {
                                TAG: /* Elem */1,
                                _0: React.createElement(MapUtils.WayPointIcon.make, {
                                      label: index
                                    })
                              }, {
                                title: wayPointTooltipTitle,
                                ts: getMarkerTs(a.location),
                                address: a.address
                              });
                  }), waypointArray) : undefined,
          cancelled: orderStatus !== 8 ? undefined : Belt_Option.flatMap(driverRoute, (function (param) {
                    var line = param.line;
                    var l = line.length;
                    if (l === 0) {
                      return ;
                    }
                    var lastCoordinate = Caml_array.get(line, l - 1 | 0);
                    return getMarker({
                                TAG: /* WithTime */0,
                                _0: lastCoordinate
                              }, {
                                TAG: /* Img */0,
                                _0: MapConfig.cancel_icon
                              }, {
                                title: cancelledTooltipTitle,
                                ts: getMarkerTs({
                                      TAG: /* WithTime */0,
                                      _0: lastCoordinate
                                    }),
                                address: "NA"
                              });
                  }))
        };
}

function groupMarkers(markers) {
  var markersList_0 = markers.accept;
  var markersList_1 = {
    hd: markers.pickup,
    tl: {
      hd: markers.drop,
      tl: {
        hd: markers.trip_start,
        tl: {
          hd: markers.trip_end,
          tl: {
            hd: markers.cancelled,
            tl: /* [] */0
          }
        }
      }
    }
  };
  var markersList = {
    hd: markersList_0,
    tl: markersList_1
  };
  var _groupMarkers = /* [] */0;
  var _unvistedMarkers = markersList;
  while(true) {
    var unvistedMarkers = _unvistedMarkers;
    var groupMarkers$1 = _groupMarkers;
    if (!unvistedMarkers) {
      return groupMarkers$1;
    }
    var tail = unvistedMarkers.tl;
    var head = unvistedMarkers.hd;
    if (head !== undefined) {
      var match = List.partition((function(head){
          return function (a) {
            if (a === undefined) {
              return false;
            }
            var d = MapUtils.getHaversineDistance(head.location, a.location);
            return d < 30.0;
          }
          }(head)), tail);
      _unvistedMarkers = match[1];
      _groupMarkers = {
        hd: {
          hd: head,
          tl: match[0]
        },
        tl: groupMarkers$1
      };
      continue ;
    }
    _unvistedMarkers = tail;
    continue ;
  };
}

var acceptClassName = "trip-accept";

var pickupClassName = "pickup";

var dropClassName = "drop";

var tripStartClassName = "trip-start";

var tripEndClassName = "trip-end";

var wayPointClassName = "waypoint";

var nearByMarkersDistance = 30.0;

export {
  acceptTooltipTitle ,
  pickupTooltipTitle ,
  dropTooltipTitle ,
  tripStartTooltipTitle ,
  tripEndTooltipTitle ,
  wayPointTooltipTitle ,
  cancelledTooltipTitle ,
  acceptClassName ,
  pickupClassName ,
  dropClassName ,
  tripStartClassName ,
  tripEndClassName ,
  wayPointClassName ,
  nearByMarkersDistance ,
  multiAnchorPoints ,
  singleAnchorPoints ,
  getTsString ,
  getMarkerTs ,
  getMarker ,
  getMarkerLatLng ,
  getSingleMarkerHolder ,
  getMultiMarkerHolder ,
  getMarkersViews ,
  groupMarkers ,
  
}
/* react Not a pure module */
